import React from 'react'
import {Box, Typography} from '@mui/material'
import UpdateOutlinedIcon from '@mui/icons-material/UpdateOutlined'
import DatePickerNew from 'src/components-new/inputs/DatePickerNew'
import TimePickerNew from 'src/components-new/inputs/TimePickerNew'
import {NEUTRAL_SCALE} from 'src/theme-new/tokens'
import SectionTitleNew from './SectionTitleNew'

// therapy-service RF3.3/RF4.4: date and time of the therapy's next dose, movable from the
// deep-link page only. Moving it shifts that single dose (and its reminder): the ones after it
// stay on the therapy's usual time.

interface NextDoseFieldsNewProps {
  value: string | null
  onChange: (value: string | null) => void
  disabled?: boolean
  error?: boolean
}

export default function NextDoseFieldsNew({value, onChange, disabled, error}: NextDoseFieldsNewProps): JSX.Element {
  return (
    <Box>
      <SectionTitleNew icon={UpdateOutlinedIcon}>Prossima assunzione</SectionTitleNew>
      <Box sx={{display: 'grid', gridTemplateColumns: {xs: '1fr', sm: '1fr 1fr'}, gap: 2}}>
        <DatePickerNew
          label="Data"
          required
          fullWidth
          disabled={disabled}
          error={error}
          minDate={new Date().toISOString()}
          value={value}
          onChange={onChange}
        />
        <TimePickerNew
          label="Ora"
          required
          fullWidth
          disabled={disabled}
          error={error}
          value={value}
          onChange={onChange}
        />
      </Box>
      <Typography variant="caption" sx={{color: error ? 'error.main' : NEUTRAL_SCALE[500], mt: 1, display: 'block'}}>
        {error
          ? 'La prossima assunzione deve essere successiva a adesso.'
          : 'Puoi spostare solo la prossima assunzione: le successive restano all\'orario abituale.'}
      </Typography>
    </Box>
  )
}
